export const PolicyReinstateConstants = {
  reinstateSuccessMessage: 'There is enough payments in suspense for this policy and have been successfully reinstated!',
};